module.exports = __webpack_public_path__ + "img/41-r.279322cd.png";